import { TextArea } from 'Components/designSystem';
import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';
import styled from 'styled-components';

import { noteSelector, setNote } from '../store';

const MAX_NOTE_LENGTH = 1000;
const MIN_NOTE_HEIGHT_PX = 200;

function OfferNoteBlock() {
    const { t } = useTranslation('candidateOffers');

    const dispatch = useAppDispatch();
    const note = useSelector(noteSelector);

    const handleNoteChange = useCallback((value: string) => {
        dispatch(setNote({ note: value }));
    }, [ dispatch ]);

    return (
        <Wrapper>
            <TextArea value={ note }
                onChange={ handleNoteChange }
                placeholder={ t('replyCommentPlaceholder') }
                maxLength={ MAX_NOTE_LENGTH } />
        </Wrapper>
    );
}

export default memo(OfferNoteBlock);

const Wrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: ${ MIN_NOTE_HEIGHT_PX }px;

    > div {
        flex: 1;
        min-height: 0;
    }

    > div > div:first-child {
        flex: 1;
        min-height: 0;
    }

    textarea {
        min-height: ${ MIN_NOTE_HEIGHT_PX }px;
        flex: 1;
    }
`;
